import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import { apmBase } from '@elastic/apm-rum';

import { Notification } from '@platform/elements';

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<object, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.log(`[ErrorBoundary] Caught an error: ${error} \n Info: ${errorInfo.componentStack}`);
    apmBase.captureError(error);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Notification title="Ups, hier ist was schiefgelaufen" type="error">
          Bei der Ausführung dieser Komponente ist leider ein Fehler unterlaufen. Laden Sie die Seite bitte neu, sollte das Problem
          weiterhin bestehen, können Sie sich gerne mit uns in Verbindung setzen.
        </Notification>
      );
    }

    // @ts-expect-error this is okay
    return this.props.children;
  }
}
